var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooths(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57997 5.53005L5.06384 2.04617C5.21083 1.89831 5.38562 1.781 5.57815 1.70101C5.77068 1.62101 5.97714 1.57991 6.18563 1.58008H12.7742C12.9827 1.57991 13.1891 1.62101 13.3817 1.70101C13.5742 1.781 13.749 1.89831 13.896 2.04617L17.3798 5.53005",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15999 9.48047V15.8004C3.15999 16.2195 3.32645 16.6213 3.62276 16.9176C3.91906 17.2139 4.32094 17.3804 4.73998 17.3804H14.2199C14.6389 17.3804 15.0408 17.2139 15.3371 16.9176C15.6334 16.6213 15.7999 16.2195 15.7999 15.8004V9.48047",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8499 17.3806V14.2206C11.8499 13.8016 11.6834 13.3997 11.3871 13.1034C11.0908 12.8071 10.689 12.6406 10.2699 12.6406H8.68993C8.27089 12.6406 7.86901 12.8071 7.57271 13.1034C7.2764 13.3997 7.10994 13.8016 7.10994 14.2206V17.3806",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57997 5.53125H17.3798",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3798 5.53125V7.90123C17.3798 8.32027 17.2134 8.72214 16.9171 9.01845C16.6208 9.31475 16.2189 9.48122 15.7999 9.48122C15.3383 9.45581 14.8975 9.28115 14.5438 8.98352C14.4495 8.9154 14.3362 8.87874 14.2199 8.87874C14.1036 8.87874 13.9902 8.9154 13.896 8.98352C13.5423 9.28115 13.1014 9.45581 12.6399 9.48122C12.1783 9.45581 11.7375 9.28115 11.3838 8.98352C11.2895 8.9154 11.1762 8.87874 11.0599 8.87874C10.9436 8.87874 10.8303 8.9154 10.736 8.98352C10.3823 9.28115 9.94147 9.45581 9.47991 9.48122C9.01834 9.45581 8.57752 9.28115 8.22382 8.98352C8.12955 8.9154 8.01622 8.87874 7.89992 8.87874C7.78362 8.87874 7.67028 8.9154 7.57602 8.98352C7.22232 9.28115 6.7815 9.45581 6.31993 9.48122C5.85837 9.45581 5.41755 9.28115 5.06384 8.98352C4.96958 8.9154 4.85624 8.87874 4.73994 8.87874C4.62365 8.87874 4.51031 8.9154 4.41605 8.98352C4.06234 9.28115 3.62152 9.45581 3.15996 9.48122C2.74092 9.48122 2.33904 9.31475 2.04274 9.01845C1.74643 8.72214 1.57997 8.32027 1.57997 7.90123V5.53125",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9598,
    height: 18.9598,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooths);
export default __webpack_public_path__ + "static/media/booths.5fa68f00b19ab7183c30ca3560e9132c.svg";
export { ForwardRef as ReactComponent };